import { lazy } from 'react';

export const LiveTournamentPageAsync = lazy(() =>
  import('./LiveTournamentPage').then((m) => ({ default: m.LiveTournamentPage })),
);
